<template>
  <div class="dsf-control dsfa-project-statistics-cloud-logs">
    <div class="logs-header">
      <div class="logs-item" v-show="showSearch">
        <form @submit.stop.prevent="getTableData()">
          <div class="search-input el-input">
            <input ref="searchInput" :placeholder="searchPlaceholder" type="text" autocomplete="off" class="el-input__inner">
          </div>
          <button class="search-button" @click="getTableData()">
            <i class="iconfont icon-fangdajing"></i>
          </button>
        </form>
      </div>
      <div v-if="showRadio" class="logs-item">
        <div class="logs-item-value">
          <el-radio-group v-model="type" @change="getTableData()">
            <el-radio-button v-for="item in typeOptions" :key="item.value" :label="item.value">{{item.text}}</el-radio-button>
          </el-radio-group>
        </div>
      </div>
    </div>
    <div ref="body" class="logs-body">
      <el-table v-if="columns.length" :data="tableData" height="100%" border stripe style="width: 100%">
        <el-table-column type="index" width="50" label="序号" fixed align="center">
        </el-table-column>
        <el-table-column v-for="column in columns" :key="column.text" :prop="column.text" :label="column.value" :min-width="column.width" :fixed="column.fixed" :align="column.align" :header-align="column.headAlign">
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfProjectStatisticsCloudLogs",
  ctrlCaption: "日志列表组件",
  mixins: [$mixins.control],
  props: {
    defaultType: {
      type: Number,
      default: 1
    },
    showRadio: {
      type: Boolean,
      default: true
    },
    searchPlaceholder: {
      type: String,
      default: '请输入检索关键字'
    },
    columnsUrl: {
      type: String,
      default: '/log/statistics/rowNames'
    },
    dataUrl: {
      type: String,
      default: '/log/statistics/rowData'
    },
    showSearch: {
      default: false
    }
  },
  data() {
    return {
      type: 1,
      typeOptions: [
        {
          text: "年",
          value: 2
        },
        {
          text: "月",
          value: 1
        }
      ],
      columns: [],
      tableData: []
    };
  },
  watch: {
    defaultType: {
      handler(to) {
        this.type = to;
      },
      immediate: true
    }
  },
  created() {
    if (this.isDesign) {
      this.$dispatch("design-height-change", "100%");
      this.columns = [
        {
          "text": "name1",
          "value": "列1",
          "align": "center",
          "headAlign": "center",
          "width": 100,
          "fixed": false
        },
        {
          "text": "name2",
          "value": "列2",
          "align": "center",
          "headAlign": "center",
          "width": 108,
          "fixed": false
        },
        {
          "text": "name3",
          "value": "列3",
          "align": "center",
          "headAlign": "center",
          "width": 100,
          "fixed": false
        }
      ]
    } else {
      this.getColumns();
    }
  },
  methods: {
    getColumns() {
      if (this.isDesign) return;
      let loading = dsf.layer.loading();
      this.$http
        .get(this.$replace(this.columnsUrl))
        .done(({success, data, message}) => {
          if (success) {
            this.columns = (data.rowNames || []).map((item) => {
              if (item.width === "" || item.width === null || item.width === undefined) {
                item.width = item.value.length * 18;
                if (item.width < 100) item.width = 100;
              }
              if (!item.fixed) {
                item.fixed = false;
              }
              if (!item.align) {
                item.align = "center";
              }
              if (!item.headAlign) {
                item.headAlign = "center";
              }
              return item;
            });
            this.getTableData(loading);
          } else {
            dsf.layer.message(message, false);
            dsf.layer.closeLoading(loading);
          }
        })
        .catch(() => {
          dsf.layer.message("内部服务器错误", false);
          dsf.layer.closeLoading(loading);
        });
    },
    getTableData(loading) {
      if (this.isDesign) return;
      if (!loading) {
        loading = dsf.layer.loading();
      }
      let searchValue = this.$refs.searchInput.value.trim();
      let params = {showType: this.type};
      if (searchValue) {
        params.searchValue = searchValue;
      }
      this.$http
        .get(this.$replace(this.dataUrl), params)
        .done(({success, data, message}) => {
          if (success) {
            this.tableData = data.rowList || [];
          } else {
            dsf.layer.message(message, false);
          }
        })
        .error(() => {
          dsf.layer.message("内部服务器错误", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    }
  }
});
</script>
